










import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import _ from 'underscore';
import GameBoardLetter from '@/components/GameBoardLetter.vue';
import { PanEvent, VueTargetElement } from '@/types';

@Component({
  components: {GameBoardLetter},
  })
export default class GameBoard extends Vue {
  private selectedLetters: VueTargetElement[] = [];
  private rows = 6;
  private columns = 6;
  @State letters!: string[];
  @State currentWord!: string;
  @Action setLetters: any;

  created() {
    this.setupBoard();
  }

  setupBoard() {
    if (this.letters.length === 0) {
      this.resetBoard();
    }
  }

  resetBoard() {
    const numOfLetters = this.rows * this.columns;
    const letters: string[] = [];
    for (let i = 0; i < numOfLetters; i++) {
      letters.push(GameBoard.randomLetter());
    }
    this.setLetters(letters);
  }

  static randomLetter(): string {
    const alphabet: string = 'abcdefghijklmnopqrstuvwxyz';
    /**
    * English language cumulative letter frequencies × 100000.
    * @see http://en.wikipedia.org/wiki/Letter_frequency
    */
    // const frequencies = [
    //   8167, 9659, 12441, 16694,
    //   29396, 31624, 33639, 39733,
    //   46699, 46852, 47624, 51649,
    //   54055, 60804, 68311, 70240,
    //   70335, 76322, 82649, 91705,
    //   94463, 95441, 97801, 97951,
    //   99925, 100000,
    // ];
    // https://boardgamegeek.com/geeklist/182883/letter-distributions-word-games
    const frequenciesAsPercent = [
      8.497, 2.072, 4.539, 3.384, 11.161, 1.812,
      2.471, 3.003, 7.545, 0.197, 1.102, 5.489,
      3.013, 6.654, 7.164, 3.167, 0.196, 7.581,
      5.735, 6.951, 3.631, 1.007, 1.290, 0.290,
      1.778, 0.272,
    ];

    const frequencySum: number[] = [];
    let sum = 0;
    frequenciesAsPercent.forEach((frequency) => {
      sum += frequency*1000;
      frequencySum.push(sum);
    });
    const random = _.random(100000);
    let letter = '';
    for (let i = 0; i < alphabet.length; i++) {
      if (random < frequencySum[i]) {
        letter = alphabet[i];
        break;
      }
    }

    return letter;
  }

  addLetter(event: Event) {
    const panEvent: PanEvent = event;
    const target: VueTargetElement = document //
      .elementFromPoint(panEvent.center.x, panEvent.center.y);
    if (target.classList.contains('gameboard-letter') && !this.selectedLetters.includes(target)) {
      target.classList.add('selected');
      this.selectedLetters.push(target);
      this.$store.dispatch('addLetter', target.__vue__.letter);
    }
  }

  startCapturing(event: Event) {
    this.$store.dispatch('startCapturing');
    this.addLetter(event);
  }

  stopCapturing() {
    if (this.currentWord.length > 1 && !this.$store.state.triedWords.includes(this.currentWord)) {
      this.$store.dispatch('tryWord', this.currentWord);
    }
    this.$store.dispatch('stopCapturing');
    this.clearSelected();
  }

  clearSelected() {
    this.selectedLetters.forEach((letter) => {
      letter.classList.remove('selected');
    });
    this.selectedLetters = [];
  }
}
